<div class="accordion-container">
    <ng-content select="core-accordion-panel"></ng-content>
</div>
